<template>
    <div>
        <f-title title="Bildarchiv" class="mt-0" />
        <v-row class="no-frame">
            <v-text-field
                label          = "Verzeichnis"
                :readonly      = "readonly"
                v-model        = "unit.imageroot"
                autocomplete   = "off"
                autocorrect    = "off"
                autocapitalize = "off"
                spellcheck     = "false"
                @input         = "onImageRoot"
                :error-messages = "errors"
            />
        </v-row>
        <v-row class="no-frame mt-2">
            <v-col class="col-12 text-center no-frame">
                <v-btn
                    text
                    @click = "onInitialize"
                    class  = "dialog-button"
                    :disabled = "errors.length > 0"
                    outlined
                >
                    Einplanen
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import FTitle from "@/modules/core/components/utils/FTitle.vue";
import Img from "@/modules/img/components/service/Img";
import Core from "@/modules/core/service/Core";

export default {
    name: "CImageCard",
    components: {
        FTitle
    },

    props: {
        unit: {

        },

        readonly: {

        }
    },

    data: () => ({
        errors: [],
    }),

    mounted() {
        this.onImageRoot();
    },

    watch: {
        unit () {
            this.onImageRoot();
        }
    },

    methods: {
        onInitialize () {
            Img.sync(this.unit.id).then ((data) => {
                this.schedule = data;
                this.onImageRoot();
            }).catch((error) => {
                Core.message.popup(this, error.id, error.parameter);
            });
        },

        onImageRoot () {
            if (!this.unit.imageroot) {
                this.errors = [ this.$t("img.root.empty") ];
                return;
            }

            Img.check(this.unit.id, this.unit.imageroot).then(result => {
                if (result.errorId) {
                    this.errors = [ this.$t(result.errorId) ]
                } else {
                    this.errors = [  ]
                }
            })
        }
    }
}
</script>

<style scoped>

</style>